import './slider-product-gallery';
import './slider-review-product';

